
const GetUsers = `
  query($count: Int, $cursor: String) {
    users(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          email
          role
        }
      }
    }
  }
`

const GetUser = `
  query($id: String!) {
    user(id: $id) {
      id
      email
      role
    }
  }
`

const UpdateUser = `
  mutation($email: String!, $role: String!) {
    updateUser(input: {
      email: $email,
      role:  $role,
    }) {
      ...on UpdateSuccess {
        id
      }
      ...on UpdateFailure {
        errorMessage
      }  
    }
  }
`

const AddUser = `
  mutation($email: String!, $role: String!) {
    addUser(input: {
      email:  $email,
      role:   $role,
    }) {
      ...on UpdateSuccess {
        id
      }
      ...on UpdateFailure {
        errorMessage
      }
    }
  }
`

const DeleteUser = `
  mutation($id: String!) {
    deleteUser(id: $id) {
      ...on UpdateSuccess {
        id
      }
      ...on UpdateFailure {
        errorMessage
      }
    }
  }
`

module.exports = {
  GetUsers,
  GetUser,
  AddUser,
  DeleteUser,
  UpdateUser,
}